/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useItemSwap } from "cms/common/hooks/use-item-swap";
import { useEnsureGuidList } from "./use-ensure-guid-list";
import { useListControls } from "./use-list-controls";

/**
 * @template {ItemWithPosition} T
 * @param {T[]} initialList
 * @param {Readonly<T>} defaultItem
 * @param {(items: T[]) => void} onChange
 */
export function useSortableComponentList (initialList, defaultItem, onChange) {
    
    const itemsWithGuid = useEnsureGuidList(initialList);
    const [list, sortableMethods] = useItemSwap(itemsWithGuid, "guid", onChange);
    const controls = useListControls(list, defaultItem, onChange);

    return {
        list,
        sortableMethods,
        controls,
    };
}
